<template>
  <div>
    <el-dialog title="选择游戏" :visible="dialogGame" top="70px" :close-on-click-modal="false" width="500px"
      @close="cancel">
      <div v-if="dialogGame">
        <el-form :inline="true" :model="formGame" class="form-inline">
          <el-form-item label="游戏名称">
            <el-input v-model="formGame.name" placeholder="游戏名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search">查询</el-button>
            <el-button type="info" @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="tableData" border style="width: 100%" :header-cell-style="{background:'#e9f1f5',}"
          v-loading="loading">
          <el-table-column width="320px" prop="relation_game_name" label="游戏名称">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="primary" @click="check(scope.row)">选择</el-button>
            </template>
          </el-table-column>


        </el-table>
        <div class="page_box" v-show="total>10">
          <el-pagination background layout="prev, pager, next" :total="total" :current-page="page"
            @current-change="currentChange" :page-size="10">
          </el-pagination>
        </div>
      </div>

    </el-dialog>
  </div>
</template>

<script>
  import {
    searchGame,
  } from "@/api/home";
  export default {
    data() {
      return {
        formGame: {
          name: ''
        },
        tableData: [],
        page: 1,
        total: 0,
        adminUser: JSON.parse(localStorage.getItem('adminUser')),
        loading: false
      }
    },
    props: {
      dialogGame: {
        default: false
      },
      type: {
        default: 'user'
      }
    },
    watch: {
      dialogGame(n, o) {
        if (n) {
          this.formGame.name = ''
          this.page = 1
          this.getData()
        }
      }
    },
    created() {
      // this.getData()
    },
    methods: {
      cancel() {
        this.$emit('update:dialogGame', false)
      },
      currentChange(v) {
        this.page = v
        this.getData()
      },
      reset() {
        this.formGame.name = ''
        this.page = 1
        this.getData()
      },
      getData() {
        this.loading = true
        let url = this.type == 'user' ? '/game/get_game_page_list' : '/admin_function/all_games'
        searchGame({
          page: this.page,
          limit: 10,
          game_name: this.formGame.name,
          admin_token: this.type == 'user' ? null : this.adminUser.admin_token
        }, url).then(res => {
          if (res.code == 20001) {
            this.$emit('openLogin')
          }
          if (res.code == 200) {
            this.tableData = res.data
            this.total = res.count
          }
          this.loading = false
        })
      },
      search() {
        this.page = 1
        this.getData()
      },
      check(v) {
        // console.log(v)
        this.$emit('checkGame', v)
      }
    }
  }
</script>

<style scoped lang="less">
  .page_box {
    margin-top: 15px;
    display: flex;
    justify-content: flex-end;
  }
</style>


// WEBPACK FOOTER //
// src/component/search_game.vue